module.exports = __webpack_public_path__ + "img/lg_ring_g_c_0_1.b81d671c.png";